import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from 'components/navbar';
import { observer } from 'mobx-react';

const BidAnalysisHoc = () => {
  useEffect(() => {
    // Any initialization logic for Bid Analysis can go here
  }, []);

  return (
    <div>
      <Navbar heading="Bid Analysis" />
      <Outlet />
    </div>
  );
};

export default observer(BidAnalysisHoc);

